<div class="wrap-1200">
  <app-ir-to-approve-table
    [projectData]="irToApprove"
    [loader]="loader"
    [translations]="translations"
    (reloadDataEmitter)="getIrToApprove()"
  ></app-ir-to-approve-table>
</div>